// Generated by Melange

import * as Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information from "./buhta_tax_control_v1alpha1_chief_information.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_field_mask from "../../third_party/google_wkt/gen/google_protobuf_field_mask.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetChiefInformationRequest = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1alpha1_chief_information_service.ml",
      661,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetChiefInformationResponse = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1alpha1_chief_information_service.ml",
      721,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateChiefInformationRequest = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1alpha1_chief_information_service.ml",
      782,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateChiefInformationResponse = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1alpha1_chief_information_service.ml",
      845,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.tax.control.v1alpha1.GetChiefInformationRequest";
}

function make(expandOpt, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          expand: expand
        };
}

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    2,
                    "expand",
                    "expand"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._2(serialize, writer, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(expand) {
  return {
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.GetChiefInformationRequest", spec(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.expand);
  };
}

function constructor$1(expand) {
  return {
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.GetChiefInformationRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetChiefInformationRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.tax.control.v1alpha1.GetChiefInformationResponse";
}

function make$1(info, param) {
  return {
          info: info
        };
}

const $$let = Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information.Buhta.Tax.Control.V1alpha1.ChiefInformation;

const merge_info = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "info",
            "info"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          info: Curry._2(merge_info, t1.info, t2.info)
        };
}

function spec$1(param) {
  const $$let = Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information.Buhta.Tax.Control.V1alpha1.ChiefInformation;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "info",
                    "info"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.info);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(info) {
  return {
          info: info
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.GetChiefInformationResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.info);
  };
}

function constructor$3(info) {
  return {
          info: info
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.GetChiefInformationResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetChiefInformationResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.tax.control.v1alpha1.UpdateChiefInformationRequest";
}

function make$2(info, field_mask, param) {
  return {
          info: info,
          field_mask: field_mask
        };
}

const $$let$1 = Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information.Buhta.Tax.Control.V1alpha1.ChiefInformation;

const merge_info$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "info",
            "info"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const $$let$2 = Google_wkt__Google_protobuf_field_mask.Google.Protobuf.FieldMask;

const merge_field_mask = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "field_mask",
            "fieldMask"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          info: Curry._2(merge_info$1, t1.info, t2.info),
          field_mask: Curry._2(merge_field_mask, t1.field_mask, t2.field_mask)
        };
}

function spec$2(param) {
  const $$let = Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information.Buhta.Tax.Control.V1alpha1.ChiefInformation;
  const $$let$1 = Google_wkt__Google_protobuf_field_mask.Google.Protobuf.FieldMask;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "info",
                    "info"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "field_mask",
                        "fieldMask"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let$1.name,
                            make: $$let$1.make,
                            from_proto: $$let$1.from_proto,
                            from_proto_exn: $$let$1.from_proto_exn,
                            to_proto: $$let$1.to_proto,
                            to_proto$p: $$let$1.to_proto$p,
                            merge: $$let$1.merge,
                            to_json: $$let$1.to_json,
                            from_json_exn: $$let$1.from_json_exn,
                            from_json: $$let$1.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.info, param.field_mask);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(info, field_mask) {
  return {
          info: info,
          field_mask: field_mask
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.UpdateChiefInformationRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.info, param.field_mask);
  };
}

function constructor$5(info, field_mask) {
  return {
          info: info,
          field_mask: field_mask
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.UpdateChiefInformationRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateChiefInformationRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.tax.control.v1alpha1.UpdateChiefInformationResponse";
}

function make$3(info, param) {
  return {
          info: info
        };
}

const $$let$3 = Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information.Buhta.Tax.Control.V1alpha1.ChiefInformation;

const merge_info$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "info",
            "info"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$3(t1, t2) {
  return {
          info: Curry._2(merge_info$2, t1.info, t2.info)
        };
}

function spec$3(param) {
  const $$let = Buhta_taxapis__Buhta_tax_control_v1alpha1_chief_information.Buhta.Tax.Control.V1alpha1.ChiefInformation;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "info",
                    "info"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.info);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(info) {
  return {
          info: info
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.UpdateChiefInformationResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.info);
  };
}

function constructor$7(info) {
  return {
          info: info
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.UpdateChiefInformationResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateChiefInformationResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

const getChiefInformation_0 = {
  name: GetChiefInformationRequest.name,
  make: GetChiefInformationRequest.make,
  from_proto: GetChiefInformationRequest.from_proto,
  from_proto_exn: GetChiefInformationRequest.from_proto_exn,
  to_proto: GetChiefInformationRequest.to_proto,
  to_proto$p: GetChiefInformationRequest.to_proto$p,
  merge: GetChiefInformationRequest.merge,
  to_json: GetChiefInformationRequest.to_json,
  from_json_exn: GetChiefInformationRequest.from_json_exn,
  from_json: GetChiefInformationRequest.from_json
};

const getChiefInformation_1 = {
  name: GetChiefInformationResponse.name,
  make: GetChiefInformationResponse.make,
  from_proto: GetChiefInformationResponse.from_proto,
  from_proto_exn: GetChiefInformationResponse.from_proto_exn,
  to_proto: GetChiefInformationResponse.to_proto,
  to_proto$p: GetChiefInformationResponse.to_proto$p,
  merge: GetChiefInformationResponse.merge,
  to_json: GetChiefInformationResponse.to_json,
  from_json_exn: GetChiefInformationResponse.from_json_exn,
  from_json: GetChiefInformationResponse.from_json
};

const getChiefInformation = [
  getChiefInformation_0,
  getChiefInformation_1
];

const updateChiefInformation_0 = {
  name: UpdateChiefInformationRequest.name,
  make: UpdateChiefInformationRequest.make,
  from_proto: UpdateChiefInformationRequest.from_proto,
  from_proto_exn: UpdateChiefInformationRequest.from_proto_exn,
  to_proto: UpdateChiefInformationRequest.to_proto,
  to_proto$p: UpdateChiefInformationRequest.to_proto$p,
  merge: UpdateChiefInformationRequest.merge,
  to_json: UpdateChiefInformationRequest.to_json,
  from_json_exn: UpdateChiefInformationRequest.from_json_exn,
  from_json: UpdateChiefInformationRequest.from_json
};

const updateChiefInformation_1 = {
  name: UpdateChiefInformationResponse.name,
  make: UpdateChiefInformationResponse.make,
  from_proto: UpdateChiefInformationResponse.from_proto,
  from_proto_exn: UpdateChiefInformationResponse.from_proto_exn,
  to_proto: UpdateChiefInformationResponse.to_proto,
  to_proto$p: UpdateChiefInformationResponse.to_proto$p,
  merge: UpdateChiefInformationResponse.merge,
  to_json: UpdateChiefInformationResponse.to_json,
  from_json_exn: UpdateChiefInformationResponse.from_json_exn,
  from_json: UpdateChiefInformationResponse.from_json
};

const updateChiefInformation = [
  updateChiefInformation_0,
  updateChiefInformation_1
];

const V1alpha1_ChiefInformationService = {
  GetChiefInformation: {
    name: "/buhta.tax.control.v1alpha1.ChiefInformationService/GetChiefInformation",
    package_name: "buhta.tax.control.v1alpha1",
    service_name: "ChiefInformationService",
    method_name: "GetChiefInformation",
    $$Request: {
      name: GetChiefInformationRequest.name,
      make: GetChiefInformationRequest.make,
      from_proto: GetChiefInformationRequest.from_proto,
      from_proto_exn: GetChiefInformationRequest.from_proto_exn,
      to_proto: GetChiefInformationRequest.to_proto,
      to_proto$p: GetChiefInformationRequest.to_proto$p,
      merge: GetChiefInformationRequest.merge,
      to_json: GetChiefInformationRequest.to_json,
      from_json_exn: GetChiefInformationRequest.from_json_exn,
      from_json: GetChiefInformationRequest.from_json
    },
    $$Response: {
      name: GetChiefInformationResponse.name,
      make: GetChiefInformationResponse.make,
      from_proto: GetChiefInformationResponse.from_proto,
      from_proto_exn: GetChiefInformationResponse.from_proto_exn,
      to_proto: GetChiefInformationResponse.to_proto,
      to_proto$p: GetChiefInformationResponse.to_proto$p,
      merge: GetChiefInformationResponse.merge,
      to_json: GetChiefInformationResponse.to_json,
      from_json_exn: GetChiefInformationResponse.from_json_exn,
      from_json: GetChiefInformationResponse.from_json
    }
  },
  getChiefInformation: getChiefInformation,
  UpdateChiefInformation: {
    name: "/buhta.tax.control.v1alpha1.ChiefInformationService/UpdateChiefInformation",
    package_name: "buhta.tax.control.v1alpha1",
    service_name: "ChiefInformationService",
    method_name: "UpdateChiefInformation",
    $$Request: {
      name: UpdateChiefInformationRequest.name,
      make: UpdateChiefInformationRequest.make,
      from_proto: UpdateChiefInformationRequest.from_proto,
      from_proto_exn: UpdateChiefInformationRequest.from_proto_exn,
      to_proto: UpdateChiefInformationRequest.to_proto,
      to_proto$p: UpdateChiefInformationRequest.to_proto$p,
      merge: UpdateChiefInformationRequest.merge,
      to_json: UpdateChiefInformationRequest.to_json,
      from_json_exn: UpdateChiefInformationRequest.from_json_exn,
      from_json: UpdateChiefInformationRequest.from_json
    },
    $$Response: {
      name: UpdateChiefInformationResponse.name,
      make: UpdateChiefInformationResponse.make,
      from_proto: UpdateChiefInformationResponse.from_proto,
      from_proto_exn: UpdateChiefInformationResponse.from_proto_exn,
      to_proto: UpdateChiefInformationResponse.to_proto,
      to_proto$p: UpdateChiefInformationResponse.to_proto$p,
      merge: UpdateChiefInformationResponse.merge,
      to_json: UpdateChiefInformationResponse.to_json,
      from_json_exn: UpdateChiefInformationResponse.from_json_exn,
      from_json: UpdateChiefInformationResponse.from_json
    }
  },
  updateChiefInformation: updateChiefInformation
};

const V1alpha1 = {
  GetChiefInformationRequest: GetChiefInformationRequest,
  GetChiefInformationResponse: GetChiefInformationResponse,
  UpdateChiefInformationRequest: UpdateChiefInformationRequest,
  UpdateChiefInformationResponse: UpdateChiefInformationResponse,
  ChiefInformationService: V1alpha1_ChiefInformationService
};

const Control = {
  V1alpha1: V1alpha1
};

const Tax = {
  Control: Control
};

const Buhta = {
  Tax: Tax
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetChiefInformationRequest Not a pure module */
